import { render, staticRenderFns } from "./SelectCustomer.vue?vue&type=template&id=0769328a&"
import script from "./SelectCustomer.vue?vue&type=script&lang=js&"
export * from "./SelectCustomer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports